module.exports = __webpack_public_path__ + "img/custom-golem.c7cd6b58.jpg";